declare namespace $ {

	type $mol_vector_2d__shm_hitalama_map_camera_url_1 = $mol_type_enforce<
		[ number, number ]
		,
		ConstructorParameters< typeof $mol_vector_2d<number> >
	>
	type $mol_vector_2d__shm_hitalama_map_camera_url_2 = $mol_type_enforce<
		[ number, number ]
		,
		ConstructorParameters< typeof $mol_vector_2d<number> >
	>
	export class $shm_hitalama_map_camera_url extends $mol_plugin {
		state_key( ): string
		zoom( next?: number ): number
		shift( next?: $mol_vector_2d<number> ): $mol_vector_2d<number>
		zoom_default( ): number
		shift_default( ): $mol_vector_2d<number>
	}
	
}

//# sourceMappingURL=url.view.tree.d.ts.map